// import fr from './lang/ca.js'
import es from './lang/es.js'
import store from '@/store'

let storeInstance = store
let allStrings = {
  es: es,
  // ca: ca
}

export function t (key) {
  // return allStrings[storeInstance.state.i18n.lang][key]|| '['+key+']'
  // lo anterior no funciona pq el string buit es un falsy
  let aux = allStrings[storeInstance.state.i18n.lang][key]
  return aux != undefined ? aux : '[' + key + ']'
}
export default {
  methods: {
    t
  }
}
